import { Fragment } from 'react';
import { Num, T } from 'gt-react';
import type { VendorPriceBreakTier } from '@erp/rpc';
import { formatUnitCost } from './unitCostFormat';

export function VendorPriceBreakTierList({
  tiers,
}: {
  tiers: readonly VendorPriceBreakTier[];
}) {
  if (tiers.length === 0) return null;
  return (
    <div className="space-y-1 text-xs">
      <div className="font-semibold uppercase tracking-wide text-muted-foreground">
        <T context="replenishment price-break tiers dropdown heading">
          Price breaks
        </T>
      </div>
      <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-right tabular-nums">
        {tiers.map((tier) => (
          <Fragment key={`${tier.tier ?? 'list'}-${tier.minQuantity}`}>
            <span>
              {tier.tier == null ? (
                <T context="replenishment price-break tiers list: one tier's minimum quantity, tier number unknown; its unit cost shows in the next column">
                  From <Num>{tier.minQuantity}</Num>
                </T>
              ) : (
                <T context="replenishment price-break tiers list: one tier's minimum quantity; its unit cost shows in the next column">
                  From <Num>{tier.minQuantity}</Num>
                </T>
              )}
            </span>
            <span>{formatUnitCost(tier.unitCost)}</span>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
